import React, { useEffect, useState } from "react";
import moment from "moment";
import { getValvesByExploitation } from "../../../Utils/exploitations/valves";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { exportTableToExcel } from "../../../Helpers/Excel/export";
import excelPng from "../../../assets/images/excel.png";
import { TableHeader, TableCell } from "./TableUI";
import { Select } from "antd";

const VolumesByValveHectare = ({ data, dateRange }) => {
    const user = useSelector((state) => state.user.userInfo);
    const [sortedData, setSortedData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const exploitationId = useParams().exploitationId;
    const [valves, setValves] = useState([]);
    const [selectedValve, setSelectedValve] = useState("all")
    const [availableValves, setAvailableValves] = useState([]);


    useEffect(() => {
        if (data.length > 0) {

            const valves = [...new Set(data.map((item) => associatedValves(item)).flat())];
            const sortedValves = valves.sort((a, b) => a - b);
            setAvailableValves(sortedValves);

            let filteredData = data;
            if (selectedValve === "all") {
                filteredData = filteredData.filter((item) => associatedValves(item).length > 0);
            }

            setSortedData(filteredData);
        }
    }, [data, selectedValve]);



    useEffect(() => {
        const fetchValves = async () => {
            try {
                const fetchedValves = await getValvesByExploitation(exploitationId);
                setValves(fetchedValves);
            } catch (error) {
                console.error("Error fetching valves:", error);
            }
        };
        fetchValves();
    }, [exploitationId]);

    const irrigationMode = (mode) => {
        switch (mode) {
            case "1":
                return "Auto";
            case "2":
                return "Semi-auto";
            case "3":
                return "Manuel";
            default:
                return "N/A";
        }
    };

    const fertilisationMode = (mode) => {
        switch (mode) {
            case "1":
                return "Basique";
            case "2":
                return "Quantitatif";
            case "3":
                return "Proportionnel";
            default:
                return "N/A";
        }
    };

    const associatedValves = (item) => {
        const res = [];
        for (let i = 1; i <= 12; i++) {
            if (Number(item[`v${i}`]) === 1) res.push(i);
        }
        return res;
    };

    const calculateValvesPercents = (sector) => {
        const openValves = associatedValves(sector);
        let totalFlow = 0;
        const flows = {};

        openValves.forEach((valveNum) => {
            const valve = valves.find((v) => v.number === valveNum);
            if (valve) {
                const flow = Number(valve.pluviometry) * valve.valve_superficie_net;
                totalFlow += flow;
                flows[valveNum] = flow;
            }
        });

        const percentages = {};
        Object.keys(flows).forEach((valveNum) => {
            percentages[valveNum] = totalFlow > 0 ? flows[valveNum] / totalFlow : 0;
        });

        return percentages;
    };

    const handleExportExcel = async () => {
        await exportTableToExcel(
            [
                "Irrigation par hectare",
                selectedValve === "all" ? "Toutes les vannes" : `Vanne ${selectedValve}`,
                `Date à partir de : ${dateRange[0]?.format("DD/MM/YYYY")} `,
                `Date jusqu'au : ${dateRange[1]?.format("DD/MM/YYYY")}`,
            ],
            ["irrigation-par-ha"],
            "irrigation-par-ha",
            [],
            [],
            user.first_name + " " + user.last_name
        );
    };

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });

        setSortedData(prevData => {
            const sortedData = [...prevData].sort((a, b) => {
                if (key === 'vanne') {
                    const valvesA = associatedValves(a);
                    const valvesB = associatedValves(b);
                    const minValveA = valvesA.length > 0 ? Math.min(...valvesA) : Infinity;
                    const minValveB = valvesB.length > 0 ? Math.min(...valvesB) : Infinity;
                    return direction === 'asc'
                        ? minValveA - minValveB
                        : minValveB - minValveA;
                }
                if (key === 'date') {
                    return direction === 'asc'
                        ? new Date(a.reception_date) - new Date(b.reception_date)
                        : new Date(b.reception_date) - new Date(a.reception_date);
                }
                return 0;
            });
            return sortedData;
        });
    };

    return (
        <>
            <div className="flex justify-between items-center mb-4">
                <div className="flex gap-3">
                    <span className="font-semibold text-md">Filtrer par vanne :</span>
                    <Select
                        style={{ width: 200 }}
                        value={selectedValve}
                        onChange={setSelectedValve}
                    >
                        <Select.Option value="all">Toutes les vannes</Select.Option>
                        {availableValves.map((valve) => (
                            <Select.Option key={valve} value={valve}>
                                Vanne {valve}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <div
                    className="flex gap-3 border p-2 hover:bg-green-200 rounded-md transition-all cursor-pointer"
                    onClick={handleExportExcel}>
                    <span className="font-bold text-lg">Export :</span>
                    <img src={excelPng} alt="" className="w-8" />
                </div>
            </div>
            <table
                className="w-full table-auto border-collapse"
                id="irrigation-par-ha">
                <thead>
                    <tr>
                        <th
                            colSpan={4}
                            className="text-2xl font-semibold p-3 bg-gray-700 text-white border-r-4 border-gray-500 table_heeader text-center"
                        >
                            Vannes
                        </th>
                        <th
                            colSpan={5}
                            className="text-2xl font-semibold p-3 bg-gray-600 text-white border-r-4 border-gray-500 table_heeader text-center"
                        >
                            Irrigation
                        </th>
                        <th
                            colSpan={11}
                            className="text-2xl font-semibold p-3 bg-gray-500 text-white border-r-4 border-gray-500 table_heeader text-center"
                        >
                            Fertilisation
                        </th>
                    </tr>
                    <tr>
                        <TableHeader
                            title="Vanne"
                            backgroundColor="#4b5563"
                            onClick={() => requestSort('vanne')}
                            isSortable={true}
                        />
                        <TableHeader
                            title="Date de Réception"
                            backgroundColor="#4b5563"
                            onClick={() => requestSort('date')}
                            isSortable={true}
                        />
                        <TableHeader title="Debut" backgroundColor="#374151" />
                        <TableHeader title="Fin" backgroundColor="#374151" />
                        <TableHeader
                            title="Pression Consigne (bar)"
                            backgroundColor="#374151"
                        />
                        <TableHeader
                            title="Pression Moyenne (bar)"
                            backgroundColor="#374151"
                        />
                        <TableHeader title="Mode Irrigation" backgroundColor="#374151" />
                        <TableHeader title="Volume (m³/ha)" backgroundColor="#374151" />
                        <TableHeader title="Durée (min)" backgroundColor="#374151" />
                        <TableHeader title="Fertilisation" backgroundColor="#1f2937" />
                        <TableHeader title="pH Moyen" backgroundColor="#1f2937" />
                        <TableHeader title="EC Moyen (mS/cm)" backgroundColor="#1f2937" />
                        <TableHeader
                            title="Volume Acide (L/ha)"
                            backgroundColor="#1f2937"
                        />
                        <TableHeader
                            title="Volume Engrais 1 (L/ha)"
                            backgroundColor="#1f2937"
                        />
                        <TableHeader
                            title="Volume Engrais 2 (L/ha)"
                            backgroundColor="#1f2937"
                        />
                        <TableHeader
                            title="Volume Engrais 3 (L/ha)"
                            backgroundColor="#1f2937"
                        />
                        <TableHeader
                            title="Volume Engrais 4 (L/ha)"
                            backgroundColor="#1f2937"
                        />
                        <TableHeader
                            title="Volume Engrais 5 (L/ha)"
                            backgroundColor="#1f2937"
                        />
                        <TableHeader title="Mode Fertilisation" backgroundColor="#1f2937" />
                    </tr>
                </thead>
                <tbody>
                    {sortedData.map((item, index) => {
                        const valveNumbers = associatedValves(item);
                        if (valveNumbers.length === 0) return null;
                        const valvesPercents = calculateValvesPercents(item);

                        return (
                            <React.Fragment key={index}>
                                {/* Sub-rows for each valve */}
                                {valveNumbers.map((valveNum, idx) => {

                                    if (selectedValve !== "all" && valveNum !== selectedValve) return null;
                                    const valve = valves.find((v) => v.number === valveNum);
                                    const percentage = valvesPercents[valveNum] || 0;
                                    const hectares = valve
                                        ? valve.valve_superficie_net // given in hectares
                                        : 1; // default to 1 if valve not found
                                    return (
                                        <tr
                                            key={`${idx}-${valveNum}`}
                                            style={{
                                                backgroundColor:
                                                    idx % 2 === 0
                                                        ? "rgb(241, 242, 244)"
                                                        : "rgba(255, 255, 255,1)",
                                            }}
                                        >
                                            <TableCell className="text-center">{`V${valveNum}`}</TableCell>
                                            <TableCell className="text-center">
                                                {moment(item.reception_date).format("DD/MM/YYYY")}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {moment(item.reception_date).subtract(item.duration, "minutes").format("HH:mm")}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {moment(item.reception_date).format("HH:mm")}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {item.p_consigne / 100}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {item.p_moyenne}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {irrigationMode(item.irrigation_mode)}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {((percentage * item.volume) / hectares).toFixed(2)}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {item.duration}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {item.fertilisation ? "Oui" : "Non"}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {item.ph_moyenne}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {item.ec_moyenne}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {((percentage * item.volume_acide) / hectares).toFixed(
                                                    2
                                                )}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {(
                                                    (percentage * item.volume_engrais_1) /
                                                    hectares
                                                ).toFixed(2)}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {(
                                                    (percentage * item.volume_engrais_2) /
                                                    hectares
                                                ).toFixed(2)}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {(
                                                    (percentage * item.volume_engrais_3) /
                                                    hectares
                                                ).toFixed(2)}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {(
                                                    (percentage * item.volume_engrais_4) /
                                                    hectares
                                                ).toFixed(2)}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                {(
                                                    (percentage * item.volume_engrais_5) /
                                                    hectares
                                                ).toFixed(2)}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {fertilisationMode(item.fertilisation_mode)}
                                            </TableCell>
                                        </tr>
                                    );
                                })}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

export default VolumesByValveHectare;
